import React from "react";
import {CoinsLeft, CoinsRight, CoinsTop, Plane, TextContent} from "./components";
import "./styles/index.scss";


const App = () => {


	return (
		<>
			<TextContent/>
			<CoinsRight/>
			<CoinsLeft/>
			<CoinsTop/>
			<Plane/>
			<svg width="547" height="437" viewBox="0 0 547 437" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path id="plane-path" preserveAspectRatio="xMaxYMax" d="M14.369,506.485 C138.403,386.217 80.033,422.952 224.409,334.359 347.761,258.666 490.616,221.365 537.631,221.365" stroke="black"/>
			</svg>
		</>
	);
}

export default App;
